import type { ReactNode } from 'react';

export type MessageListItemProps = {
  sender: string;
  subject: string;
  preview?: string;
  /** Short, human date shown on the row (e.g. "09:42", "Hier", "3 oct."). */
  date: string;
  /** Machine-readable date (ISO 8601) for the `<time>` element. */
  dateTime: string;
  /** Emphasizes the row as still awaiting attention. */
  unread?: boolean;
  selected?: boolean;
  /** Passive `Tag`s describing what the message contains (quote, meeting, attachments). */
  tags?: ReactNode;
  onClick: () => void;
  'data-testid'?: string;
};

const MAX_INITIALS = 2;

export function getSenderInitials(sender: string): string {
  const name = sender.includes('@') ? sender.split('@')[0] : sender;
  const words = name
    .split(/[\s._-]+/)
    .map((word) => word.replace(/[^\p{L}\p{N}]/gu, ''))
    .filter(Boolean);

  if (words.length === 0) {
    return '?';
  }

  return words
    .slice(0, MAX_INITIALS)
    .map((word) => word.charAt(0).toLocaleUpperCase('fr-FR'))
    .join('');
}

export function useMessageListItem(props: MessageListItemProps) {
  return {
    initials: getSenderInitials(props.sender),
    hasTags: Boolean(props.tags),
  };
}
